<script lang="ts" setup>
import { computed } from 'vue'
import { v4 as uuid } from 'uuid'
import { brand } from '@/config/brands'

defineProps<{
  title: string | null | undefined
  collections: any[]
  allData: any
  ending: boolean
  fetching: boolean
  setInfiniteRef: (el: HTMLElement | null) => void
  handleBookClick: (bookId: string) => void
  noMoreText: string
  loadingText: string
}>()

const isTalewave = computed(() => brand === 'talewave')
</script>

<template>
  <div :ref="setInfiniteRef" class="h-100dvh overflow-scroll" :class="isTalewave ? 'talewave-collection-root' : 'bg-n-bg-global'">
    <BasicNavbar class="color-n-text-2" />

    <div class="w-full h-40px flex items-center justify-center fixed top-0 z-9 bg-n-bg-global font-medium text-n-text-1">
      {{ title }}
    </div>

    <div class="mt-50px px-5">
      <div v-for="(item, index) in collections" :key="index">
        <div
          class="mb-15px flex items-center space-x-15px cursor-pointer"
          @click="handleBookClick(item.id)"
        >
          <BizBookCover
            :id="uuid()"
            :src="item.contentCoverUrl || ''"
            :extra="{
              module_name: allData.showName,
              module_id: allData.id,
              module_type: allData.columnType,
              author: item.authorInfo.author,
              ...item,
            }"
            class="w-18 rounded"
          />

          <div class="flex-1 overflow-hidden">
            <p class="text-15px font-bold line-clamp-1 text-n-text-1">
              {{ item.contentName }}
            </p>
            <p class="text-13px mt-10px text-n-text-2 line-clamp-2">
              {{ item.introduce }}
            </p>

            <BizShowTags v-if="item.tagList && item.tagList.length" :tags="item.tagList" class="mt-10px" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="ending" class="py-15px text-13px text-center text-n-text-3">
      {{ noMoreText }}
    </div>
    <div v-else-if="fetching" class="py-15px flex items-center justify-center space-x-4 text-13px text-n-text-3">
      <div class="animate-spin">
        <i-icon-park-outline-loading />
      </div>
      <p>{{ loadingText }}</p>
    </div>
  </div>
</template>
